// LandingPage.js
// TODO: Replace placeholder texts, images, and links with real content.
// This page is mobile-first and uses TailwindCSS. Light theme only.

import React, { useState, useEffect, useRef } from 'react';
// Importing the logo from the sibling project. CRACO removes ModuleScopePlugin to allow this.
import Logo from '../../temp2docWebSite/src/assets/images/temp2doc-logo.svg';
import { trackButtonClick, trackPageView, trackNavigation } from './analytics';
import SEOMetaTags from './components/SEOMetaTags';

function NavBar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    // Track mobile menu toggle event
    trackButtonClick("mobile_menu_toggle", mobileMenuOpen ? "close" : "open", "navigation");
  };

  // Close mobile menu when clicking on a link
  const handleMobileLinkClick = (section, label) => {
    setMobileMenuOpen(false);
    // Track mobile navigation link click with landingPage prefix
    trackNavigation(section, label);
  };

  // PDF Tools dropdown state and handlers
  const [isPdfToolsDropdownOpen, setIsPdfToolsDropdownOpen] = useState(false);
  const pdfToolsDropdownRef = useRef(null);
  const togglePdfToolsDropdown = () => {
    setIsPdfToolsDropdownOpen((prev) => !prev);
  };
  // simple navigate fallback (no react-router-dom in project)
  const navigate = (path) => {
    window.location.href = path;
  };
  // Mobile PDF Tools submenu state
  const [mobilePdfToolsOpen, setMobilePdfToolsOpen] = useState(false);
  const toggleMobilePdfTools = () => {
    const next = !mobilePdfToolsOpen;
    setMobilePdfToolsOpen(next);
    // Track mobile pdf tools toggle
    trackButtonClick("mobile_pdf_tools_toggle", next ? "open" : "close", "navigation");
  };
  // Close dropdown on outside click or ESC
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        pdfToolsDropdownRef.current &&
        !pdfToolsDropdownRef.current.contains(e.target)
      ) {
        setIsPdfToolsDropdownOpen(false);
      }
    };
    const handleEsc = (e) => {
      if (e.key === 'Escape') setIsPdfToolsDropdownOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEsc);
    };
  }, []);

  return (
    <nav className="sticky top-0 z-50 border-b border-gray-200 bg-white/80 backdrop-blur supports-[backdrop-filter]:bg-white/60">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-20 items-center justify-between">
          <div className="flex items-center">
            <a href="/" className="flex items-center gap-3 focus:outline-none focus:ring-2 focus:ring-primary-500 rounded">
              <img src={Logo} alt="Temp2Doc" className="h-9 w-auto" style={{ minWidth: 25, minHeight: 25 }} />
             {/* <span className="text-base font-semibold text-gray-900">temp2doc</span>*/}
            </a>
            {/* PDF Tools Dropdown (near logo) */}
            <div className="relative hidden md:block ml-2" ref={pdfToolsDropdownRef}>
              <button 
                onClick={togglePdfToolsDropdown}
                className="text-gray-700 hover:text-primary-600 px-3 py-2 nav-text-small font-medium transition-colors inline-flex items-center"
              >
                Free PDF Tools
                <svg className={`ml-1 w-4 h-4 transition-transform ${isPdfToolsDropdownOpen ? 'rotate-180' : ''}`} fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
              {/* PDF Tools Dropdown Menu */}
              {isPdfToolsDropdownOpen && (
                <div className="absolute left-0 mt-2 w-56 bg-white rounded-md shadow-lg py-1 z-10 border border-gray-200">
                   <button 
                      className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      onClick={() => {
                        setIsPdfToolsDropdownOpen(false);
                        navigate('/chat-with-pdf');
                      }}
                    >
                      Chat PDF With AI
                    </button>
                    <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/merge-pdf');
                    }}
                  >
                    Merge PDF
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/split-remove-rotate-pdf');
                    }}
                  >
                    Split Remove Rotate PDF
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/pdf-to-word');
                    }}
                  >
                    PDF to Word
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/pdf-to-excel');
                    }}
                  >
                    PDF to Excel
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/pdf-to-image');
                    }}
                  >
                    PDF to Image
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/pdf-to-powerpoint');
                    }}
                  >
                    PDF to PowerPoint
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/protect-pdf');
                    }}
                  >
                    Protect PDF
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/unlock-pdf');
                    }}
                  >
                    Unlock PDF
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/transform-pdf');
                    }}
                  >
                    Repair & Transform PDF
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/compress-pdf');
                    }}
                  >
                    Compress PDF
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/diagnose-pdf');
                    }}
                  >
                    Verify & Diagnose PDF
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="hidden md:flex items-center gap-10 text-base">
            <a 
              href="#features" 
              onClick={() => trackNavigation("features", "Features Section")}
              className="text-gray-600 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary-500 rounded"
            >
              Features
            </a>
            <a 
              href="#how" 
              onClick={() => trackNavigation("how", "How It Works Section")}
              className="text-gray-600 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary-500 rounded"
            >
              How it works
            </a>
            <a 
              href="#faq" 
              onClick={() => trackNavigation("faq", "FAQ Section")}
              className="text-gray-600 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary-500 rounded"
            >
              FAQ
            </a>
            <a 
              href="#contact" 
              onClick={() => trackNavigation("contact", "Contact Section")}
              className="text-gray-600 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary-500 rounded"
            >
              Contact
            </a>
            {/* PDF Tools moved near logo */}
          </div>
          {/* Mobile menu button */}
          <div className="lg:hidden">
            <button
              onClick={toggleMobileMenu}
              aria-expanded={mobileMenuOpen}
              aria-controls="mobile-menu"
              aria-label="Toggle mobile menu"
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500"
            >
              <svg className="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                {mobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu dropdown */}
      <div 
        id="mobile-menu"
        className={`md:hidden absolute w-full bg-white border-b border-gray-200 shadow-lg transition-all duration-300 ease-in-out ${mobileMenuOpen ? 'max-h-screen opacity-100 overflow-y-auto' : 'max-h-0 opacity-0 overflow-hidden'}`}
        aria-hidden={!mobileMenuOpen}
      >
        <div className="px-4 py-3 space-y-1">
                    {/* Mobile PDF Tools submenu */}
                    <button
            onClick={toggleMobilePdfTools}
            aria-expanded={mobilePdfToolsOpen}
            aria-controls="mobile-pdf-tools"
            className="w-full py-3 px-4 text-base text-gray-700 hover:bg-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 flex items-center justify-between"
          >
            <span>Free PDF Tools</span>
            <svg className={`w-5 h-5 text-gray-500 transition-transform ${mobilePdfToolsOpen ? 'rotate-180' : ''}`} fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
          <div
            id="mobile-pdf-tools"
            className={`pl-6 transition-all duration-300 ease-in-out ${mobilePdfToolsOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}
          >
            <button
              className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
              onClick={() => {
                trackNavigation('pdf_tools', 'chat_with_pdf');
                setMobileMenuOpen(false);
                setMobilePdfToolsOpen(false);
                navigate('/chat-with-pdf');
              }}
            >
              Chat PDF With AI
            </button>       
            <button
              className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
              onClick={() => {
                trackNavigation('pdf_tools', 'merge_pdf');
                setMobileMenuOpen(false);
                setMobilePdfToolsOpen(false);
                navigate('/merge-pdf');
              }}
            >
              Merge PDF
            </button>
            <button
              className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
              onClick={() => {
                trackNavigation('pdf_tools', 'split_remove_rotate_pdf');
                setMobileMenuOpen(false);
                setMobilePdfToolsOpen(false);
                navigate('/split-remove-rotate-pdf');
              }}
            >
              Split Remove Rotate PDF
            </button>         
            <button
              className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
              onClick={() => {
                trackNavigation('pdf_tools', 'pdf_to_word');
                setMobileMenuOpen(false);
                setMobilePdfToolsOpen(false);
                navigate('/pdf-to-word');
              }}
            >
              PDF to Word
            </button>
            <button
              className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
              onClick={() => {
                trackNavigation('pdf_tools', 'pdf_to_excel');
                setMobileMenuOpen(false);
                setMobilePdfToolsOpen(false);
                navigate('/pdf-to-excel');
              }}
            >
              PDF to Excel
            </button>
            <button
              className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
              onClick={() => {
                trackNavigation('pdf_tools', 'pdf_to_image');
                setMobileMenuOpen(false);
                setMobilePdfToolsOpen(false);
                navigate('/pdf-to-image');
              }}
            >
              PDF to Image
            </button>
            <button
              className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
              onClick={() => {
                trackNavigation('pdf_tools', 'pdf_to_powerpoint');
                setMobileMenuOpen(false);
                setMobilePdfToolsOpen(false);
                navigate('/pdf-to-powerpoint');
              }}
            >
              PDF to PowerPoint
            </button>
            <button
              className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
              onClick={() => {
                trackNavigation('pdf_tools', 'protect_pdf');
                setMobileMenuOpen(false);
                setMobilePdfToolsOpen(false);
                navigate('/protect-pdf');
              }}
            >
              Protect PDF
            </button>
            <button
              className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
              onClick={() => {
                trackNavigation('pdf_tools', 'unlock_pdf');
                setMobileMenuOpen(false);
                setMobilePdfToolsOpen(false);
                navigate('/unlock-pdf');
              }}
            >
              Unlock PDF
            </button>
            <button
              className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
              onClick={() => {
                trackNavigation('pdf_tools', 'transform_pdf');
                setMobileMenuOpen(false);
                setMobilePdfToolsOpen(false);
                navigate('/transform-pdf');
              }}
            >
              Repair & Transform PDF
            </button>
            <button
              className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
              onClick={() => {
                trackNavigation('pdf_tools', 'compress_pdf');
                setMobileMenuOpen(false);
                setMobilePdfToolsOpen(false);
                navigate('/compress-pdf');
              }}
            >
              Compress PDF
            </button>
            <button
              className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
              onClick={() => {
                trackNavigation('pdf_tools', 'diagnose_pdf');
                setMobileMenuOpen(false);
                setMobilePdfToolsOpen(false);
                navigate('/diagnose-pdf');
              }}
            >
              Verify & Diagnose PDF
            </button>
          </div>
          <a 
            href="#features" 
            onClick={() => handleMobileLinkClick('features', 'Features Section')}
            className="block w-full py-3 px-4 text-base text-gray-700 hover:bg-gray-100 hover:text-primary-600 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500"
          >
            Features
          </a>
          <a 
            href="#how" 
            onClick={() => handleMobileLinkClick('how', 'How It Works Section')}
            className="block w-full py-3 px-4 text-base text-gray-700 hover:bg-gray-100 hover:text-primary-600 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500"
          >
            How it works
          </a>
          <a 
            href="#faq" 
            onClick={() => handleMobileLinkClick('faq', 'FAQ Section')}
            className="block w-full py-3 px-4 text-base text-gray-700 hover:bg-gray-100 hover:text-primary-600 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500"
          >
            FAQ
          </a>
          <a 
            href="#contact" 
            onClick={() => handleMobileLinkClick('contact', 'Contact Section')}
            className="block w-full py-3 px-4 text-base text-gray-700 hover:bg-gray-100 hover:text-primary-600 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500"
          >
            Contact
          </a>
        </div>
      </div>
    </nav>
  );
}

function Hero() {
  return (
    <section className="relative bg-gradient-to-br from-primary-50 to-blue-100 py-20 lg:py-32 overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Content */}
          <div className="text-center lg:text-left">
            {/* Badge */}
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-primary-100 text-primary-800 text-sm font-medium mb-8 animate-fade-in">
              <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
              </svg>
              AI-Powered PDF Generation
            </div>

            {/* Main heading */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 animate-slide-up leading-tight">
              Design and Generate PDF Documents
              <span className="block text-primary-600">in Minutes</span>
            </h1>

            {/* Subheading */}
            <p
              className="text-xl text-gray-600 mb-8 max-w-xl mx-auto lg:mx-0 animate-slide-up"
              style={{ animationDelay: '0.1s' }}
            >
              Transform any content into professional, beautifully designed PDFs with our AI-powered platform.
              No design skills required—just upload, customize, and generate.
            </p>
            
            {/* Feature highlights */}
            <div
              className="flex flex-wrap justify-center lg:justify-start gap-6 text-sm text-gray-600 animate-slide-up mb-8"
              style={{ animationDelay: '0.3s' }}
            >
              <div className="flex items-center space-x-2">
                <svg className="w-5 h-5 text-purple-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span>99+ templates</span>
              </div>
            </div>
            
            {/* No CTA Buttons as per request */}
          </div>

          {/* Right side - Image/Screenshot placeholder */}
          <div className="flex justify-center lg:justify-end animate-slide-up" style={{ animationDelay: '0.4s' }}>
            <div className="relative max-w-lg w-full">
              {/* Main mockup container */}
              <div className="bg-white rounded-xl shadow-2xl p-6 border border-gray-200">
                {/* Mockup header */}
                <div className="flex items-center space-x-2 mb-4">
                  <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                  <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                  <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                  <div className="flex-1 bg-gray-100 h-6 rounded ml-4"></div>
                </div>

                {/* Mockup content */}
                <div className="space-y-4">
                  {/* Document preview */}
                  <div className="bg-gray-50 rounded-lg p-4 border-2 border-dashed border-gray-300">
                    <div className="flex items-center justify-center h-32 text-gray-400">
                      <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H7a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
                      </svg>
                    </div>
                    <p className="text-center text-sm text-gray-500 mt-2">PDF Preview</p>
                  </div>

                  {/* Control buttons */}
                  <div className="flex space-x-2">
                    <div className="flex-1 bg-primary-100 h-10 rounded-lg flex items-center justify-center">
                      <span className="text-primary-600 text-sm font-medium">Generate PDF</span>
                    </div>
                    <div className="w-10 h-10 bg-gray-100 rounded-lg"></div>
                    <div className="w-10 h-10 bg-gray-100 rounded-lg"></div>
                  </div>
                </div>
              </div>

              {/* Floating elements for visual appeal */}
              <div className="absolute -top-4 -right-4 w-8 h-8 bg-primary-500 rounded-full opacity-80 animate-bounce"></div>
              <div className="absolute -bottom-4 -left-4 w-6 h-6 bg-blue-500 rounded-full opacity-60 animate-pulse"></div>
              <div className="absolute top-1/2 -left-8 w-4 h-4 bg-purple-500 rounded-full opacity-70"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}



function Features() {
  const features = [
    {
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
        </svg>
      ),
      title: "Dynamic Templates",
      description:
        "Choose from 99+ professionally designed templates that adapt to your content automatically. Smart layouts adjust to fit your data perfectly.",
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
          <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
        </svg>
      ),
      title: "Powerful API",
      description:
        "Integrate PDF generation directly into your workflow with our RESTful API. Generate thousands of documents per minute with enterprise-grade reliability.",
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      ),
      title: "No-Code Integration",
      description:
        "Connect with Zapier, webhooks, and popular tools without writing code. Drag-and-drop interface makes automation accessible to everyone.",
    },
  ];

  return (
    <section id="features" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Everything you need to create perfect PDFs
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From simple documents to complex reports, our platform provides all the tools 
            you need to generate professional PDFs at scale.
          </p>
        </div>

        {/* Features grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className="group bg-white rounded-xl p-8 shadow-lg border border-gray-200 hover:shadow-xl hover:scale-105 transition-all duration-300 cursor-pointer"
              style={{
                animationDelay: `${index * 0.1}s`
              }}
              onClick={() => trackNavigation(`feature_${feature.title.toLowerCase().replace(/\s+/g, '_')}`, 'Features Section')}
            >
              <div className="animate-fade-in">
                {/* Icon */}
                <div className="inline-flex items-center justify-center w-16 h-16 bg-primary-100 text-primary-600 rounded-lg mb-6 group-hover:bg-primary-200 transition-colors duration-300">
                  {feature.icon}
                </div>

                {/* Title */}
                <h3 className="text-xl font-semibold text-gray-900 mb-4 group-hover:text-primary-600 transition-colors duration-300">
                  {feature.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

function HowItWorks() {
  const steps = [
    {
      number: '01',
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" clipRule="evenodd" />
        </svg>
      ),
      title: 'Design Template',
      description:
        'Choose from 99+ professional templates or create your own custom design with our drag-and-drop editor.',
    },
    {
      number: '02',
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
        </svg>
      ),
      title: 'Connect Data',
      description:
        'Link your data sources from spreadsheets, databases, APIs, or automation tools like Zapier and Make.',
    },
    {
      number: '03',
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
        </svg>
      ),
      title: 'Generate PDF',
      description:
        'Our AI engine automatically populates your template with data and generates publication-ready PDFs in seconds.',
    },
    {
      number: '04',
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
          <path d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" />
        </svg>
      ),
      title: 'Share & Automate',
      description:
        'Download, email, or automatically deliver PDFs to your customers, partners, or internal systems.',
    },
  ];

  return (
    <section id="how" aria-labelledby="how-title" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 id="how-title" className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">How It Works</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Transform your data into professional PDFs in just four simple steps.
            No technical expertise required—our platform handles all the complexity for you.
          </p>
        </div>

        {/* Steps container */}
        <div className="relative">
          {/* Desktop layout - horizontal */}
          <div className="hidden lg:block">
            {/* Connection line */}
            <div className="absolute top-16 left-1/2 transform -translate-x-1/2 w-3/4 h-0.5 bg-gray-200"></div>

            <div className="grid grid-cols-4 gap-8">
              {steps.map((step, index) => (
                <div
                  key={step.number}
                  className="relative text-center cursor-pointer"
                  style={{
                    animationDelay: `${index * 0.2}s`
                  }}
                  onClick={() => trackNavigation(`how_it_works_${step.title.toLowerCase().replace(/\s+/g, '_')}`, 'How It Works Section')}
                >
                  <div className="animate-fade-in">
                    {/* Step number */}
                    <div className="relative inline-flex items-center justify-center w-16 h-16 bg-primary-600 text-white rounded-full font-bold text-lg mb-6 z-10">
                      {step.number}
                    </div>

                    {/* Icon */}
                    <div className="inline-flex items-center justify-center w-12 h-12 bg-primary-100 text-primary-600 rounded-lg mb-4">
                      {step.icon}
                    </div>

                    {/* Title */}
                    <h3 className="text-xl font-semibold text-gray-900 mb-3">
                      {step.title}
                    </h3>

                    {/* Description */}
                    <p className="text-gray-600 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Mobile layout - vertical */}
          <div className="lg:hidden space-y-8">
            {steps.map((step, index) => (
              <div
                key={step.number}
                className="flex items-start space-x-6 cursor-pointer"
                style={{
                  animationDelay: `${index * 0.2}s`
                }}
                onClick={() => trackNavigation(`how_it_works_${step.title.toLowerCase().replace(/\s+/g, '_')}`, 'How It Works Section')}
              >
                <div className="animate-fade-in flex-shrink-0">
                  {/* Step number */}
                  <div className="inline-flex items-center justify-center w-12 h-12 bg-primary-600 text-white rounded-full font-bold text-lg">
                    {step.number}
                  </div>
                </div>

                <div className="animate-fade-in flex-1">
                  {/* Icon */}
                  <div className="inline-flex items-center justify-center w-10 h-10 bg-primary-100 text-primary-600 rounded-lg mb-3">
                    {step.icon}
                  </div>

                  {/* Title */}
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {step.title}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

       
      </div>
    </section>
  );
}

function FAQ() {
  const [openQuestion, setOpenQuestion] = useState(null);

  const faqs = [
    {
      id: 1,
      question: "How does the PDF generation work?",
      answer: "Our platform uses advanced AI algorithms to automatically format your data into professional PDF documents. Simply select a template, connect your data source (spreadsheet, database, or API), and our system handles the rest. The entire process typically takes just a few seconds."
    },
    {
      id: 2,
      question: "Can I customize the templates?",
      answer: "Absolutely! All templates are fully customizable. You can modify colors, fonts, layouts, add your logo and branding, and even create completely custom templates from scratch using our drag-and-drop editor. Pro and Business plans include advanced customization options and custom template creation."
    },
    {
      id: 3,
      question: "What data sources do you support?",
      answer: "We support a wide variety of data sources including CSV files, Excel spreadsheets, Google Sheets, databases (MySQL, PostgreSQL, MongoDB), REST APIs, webhooks, and popular tools like Airtable, Zapier, Make, and hundreds of other integrations through our API."
    },
    {
      id: 4,
      question: "Is there an API for developers?",
      answer: "Yes! We offer a comprehensive RESTful API that allows developers to integrate PDF generation directly into their applications. The API supports all major programming languages and includes detailed documentation, code examples, and SDKs for popular frameworks."
    },
    {
      id: 5,
      question: "How secure is my data?",
      answer: "Security is our top priority. All data is encrypted in transit and at rest using industry-standard AES-256 encryption. We're SOC 2 Type II compliant, GDPR compliant, and never store your sensitive data longer than necessary for processing. Enterprise customers can also use our on-premise deployment option."
    },
    {
      id: 6,
      question: "What if I need help getting started?",
      answer: "We're here to help! All plans include comprehensive documentation, video tutorials, and email support. Pro and Business customers get priority support, and Business customers also receive phone support and a dedicated account manager. We also offer onboarding sessions for teams."
    }
  ];

  const toggleQuestion = (questionId, questionText) => {
    const isOpening = openQuestion !== questionId;
    setOpenQuestion(isOpening ? questionId : null);
    
    // Track FAQ interaction
    if (isOpening) {
      trackButtonClick("faq_question_open", questionText, "engagement");
    }
  };

  return (
    <section id="faq" aria-labelledby="faq-title" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 id="faq-title" className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Everything you need to know about Temp2Doc. Can't find what you're looking for?
            <a href="#contact" className="text-primary-600 hover:text-primary-700 ml-1">
              Contact our support team
            </a>.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => {
            const isOpen = openQuestion === faq.id;
            const buttonId = `faq-button-${faq.id}`;
            const panelId = `faq-panel-${faq.id}`;
            return (
              <div
                key={faq.id}
                className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden transition-all duration-200 hover:shadow-md"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="animate-fade-in">
                  <button
                    id={buttonId}
                    aria-controls={panelId}
                    aria-expanded={isOpen}
                    onClick={() => toggleQuestion(faq.id, faq.question)}
                    className="w-full px-6 py-6 text-left flex items-center justify-between focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-inset"
                  >
                    <h3 className="text-lg font-semibold text-gray-900 pr-4">
                      {faq.question}
                    </h3>
                    <div className="flex-shrink-0">
                      <svg
                        className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${isOpen ? 'transform rotate-180' : ''}`}
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </div>
                  </button>

                  <div
                    id={panelId}
                    role="region"
                    aria-labelledby={buttonId}
                    className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}
                  >
                    <div className="px-6 pb-6">
                      <div className="border-t border-gray-200 pt-4">
                        <p className="text-gray-600 leading-relaxed">
                          {faq.answer}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16 p-8 bg-gradient-to-r from-primary-50 to-blue-50 rounded-2xl border border-primary-200">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Still have questions?
          </h3>
          <p className="text-gray-600 mb-6">
            Our support team is here to help you get the most out of Temp2Doc.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="mailto:support@temp2doc.com"
              onClick={() => trackButtonClick("contact_support", "faq_section", "engagement")}
              className="bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 inline-flex items-center justify-center"
              role="button"
              aria-label="Contact Support via email"
            >
              Contact Support
            </a>
           
          </div>
        </div>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer className="border-t border-gray-200 bg-white py-10" role="contentinfo">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          <a
            href="/"
            className="flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-primary-500 rounded"
          >
            <img
              src={Logo}
              alt="temp2doc"
              className="min-w-[25px] min-h-[25px] w-10 h-10" 
            />
            <span className="font-bold text-lg">temp2doc</span>
          </a>
          <nav className="flex flex-wrap items-center gap-4 text-sm">
            <a 
              href="#features" 
              onClick={() => trackNavigation('features', 'Footer Navigation')}
              className="text-base text-gray-600 hover:text-gray-900"
            >
              Features
            </a>
            <a 
              href="#how" 
              onClick={() => trackNavigation('how', 'Footer Navigation')}
              className="text-base text-gray-600 hover:text-gray-900"
            >
              How it works
            </a>
            <a 
              href="#faq" 
              onClick={() => trackNavigation('faq', 'Footer Navigation')}
              className="text-base text-gray-600 hover:text-gray-900"
            >
              FAQ
            </a>
            <a 
              id="contact" 
              href="mailto:support@temp2doc.com" 
              onClick={() => trackNavigation('contact', 'Footer Navigation')}
              className="text-base text-gray-600 hover:text-gray-900"
            >
              Contact
            </a>
          </nav>
        </div>
        <p className="mt-6 text-center text-xs text-gray-500"> 2025 Temp2Doc. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default function LandingPage() {
  // Track page view when component mounts
  useEffect(() => {
    // Only track on client-side to avoid hydration issues
    if (typeof window !== 'undefined') {
      trackPageView(window.location.pathname);
    }
    
    // Track user geolocation and other data is automatically handled by GA4
  }, []);
  
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <SEOMetaTags
        title="Temp2Doc - Free PDF Tools, Converters & Editor Online"
        description="Convert, edit, and interact with PDF documents online for free. No registration required. All PDF operations processed in your browser for complete privacy."
        keywords="pdf tools, pdf converter, free pdf editor, pdf to word, pdf to excel, pdf to image, merge pdf, split pdf, chat with pdf"
        canonicalUrl="https://temp2doc.com"
        structuredData={[
          {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Temp2Doc",
            "url": "https://temp2doc.com",
            "applicationCategory": "UtilitiesApplication",
            "operatingSystem": "Any",
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "USD"
            },
            "description": "Free online PDF tools and converters. Convert, edit, and interact with PDF documents online without registration.",
            "potentialAction": {
              "@type": "SearchAction",
              "target": "https://temp2doc.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string"
            }
          },
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "How does the PDF generation work?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Our platform uses advanced AI algorithms to automatically format your data into professional PDF documents. Simply select a template, connect your data source (spreadsheet, database, or API), and our system handles the rest. The entire process typically takes just a few seconds."
                }
              },
              {
                "@type": "Question",
                "name": "Can I customize the templates?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Absolutely! All templates are fully customizable. You can modify colors, fonts, layouts, add your logo and branding, and even create completely custom templates from scratch using our drag-and-drop editor. Pro and Business plans include advanced customization options and custom template creation."
                }
              },
              {
                "@type": "Question",
                "name": "What data sources do you support?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "We support a wide variety of data sources including CSV files, Excel spreadsheets, Google Sheets, databases (MySQL, PostgreSQL, MongoDB), REST APIs, webhooks, and popular tools like Airtable, Zapier, Make, and hundreds of other integrations through our API."
                }
              },
              {
                "@type": "Question",
                "name": "Is there an API for developers?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes! We offer a comprehensive RESTful API that allows developers to integrate PDF generation directly into their applications. The API supports all major programming languages and includes detailed documentation, code examples, and SDKs for popular frameworks."
                }
              },
              {
                "@type": "Question",
                "name": "How secure is my data?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Security is our top priority. All data is encrypted in transit and at rest using industry-standard AES-256 encryption. We're SOC 2 Type II compliant, GDPR compliant, and never store your sensitive data longer than necessary for processing. Enterprise customers can also use our on-premise deployment option."
                }
              },
              {
                "@type": "Question",
                "name": "What if I need help getting started?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "We're here to help! All plans include comprehensive documentation, video tutorials, and email support. Pro and Business customers get priority support, and Business customers also receive phone support and a dedicated account manager. We also offer onboarding sessions for teams."
                }
              }
            ]
          }
        ]}
      />
      <NavBar />
      <main className="min-h-screen bg-gradient-to-b from-white to-blue-50">
        <Hero />
        <Features />
        <HowItWorks />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
